import React from 'react';

const Loader = () => {
    return (
        <div className='loading'>
            <span></span>
        </div>
    );
};

export default Loader;
